// THE ACTIVITY A SHOP DRAWING HANGS OFF, AS ITS FULL PATH.
//
// Owner, 2026-10-13: "show full path like we do on digest so user can
// understand which activity parent he is working in". One small line, used
// under a drawing's name in the register, under the activity picker on the
// Add and Edit forms, in the Levels & Areas page's area panel and in the
// schedule's activity drawer - so the path reads the same everywhere.
//
// It prints the server's string (back/utils/activityPath, the digest's
// builder) and WRAPS rather than truncating: the point is to see the parents.
import React from "react";
import { activityFullPath } from "helpers/schedule/activityLabel";

export default function ActivityPathLine({ activity, level = "", area = "", missing = false, style = {}, prefix = "" }) {
  if (missing) {
    return (
      <div style={{ color: "#B45309", fontSize: 12, ...style }}>
        The schedule activity this hung off is no longer on the schedule
      </div>
    );
  }
  const full = activityFullPath(activity);
  if (!full) return null;
  const place = [level, area].filter(Boolean).join(" · ");
  return (
    <div data-testid="activity-path" title={full}
         style={{ color: "#667085", fontSize: 12, lineHeight: 1.35, whiteSpace: "normal", wordBreak: "break-word", ...style }}>
      {prefix ? <span style={{ color: "#98a2b3" }}>{prefix} </span> : null}
      {full}
      {place ? <span style={{ color: "#98a2b3" }}> · {place}</span> : null}
    </div>
  );
}
